import { Component, h, Prop, Element } from "@stencil/core"
import { FlipDirection } from "../../core/types/types"

@Component({
  tag: "sdx-flip",
  shadow: true,
})
export class Flip {
  @Element() public el!: HTMLSdxFlipElement

  /**
   * Mirror the content across one or both axes (or none at all).
   */
  @Prop() public direction: FlipDirection = "none"

  public componentWillLoad() {
    this.el.style.display = "inline-block" // make transformable
    this.el.style.transform = `scaleX(${this.getFlipTransformStyle(
      "x"
    )}) scaleY(${this.getFlipTransformStyle("y")})`
  }

  private getFlipTransformStyle(axis: "x" | "y"): number {
    const map: { [index: string]: { [index: string]: number } } = {
      none: {
        x: 1,
        y: 1,
      },
      horizontal: {
        x: -1,
        y: 1,
      },
      vertical: {
        x: 1,
        y: -1,
      },
      both: {
        x: -1,
        y: -1,
      },
    }

    return map[this.direction][axis]
  }

  public render() {
    return <slot />
  }
}
